import IgMobileDrawer from "@intelligems/ig-theme/mobile/IgMobileDrawer";
import { useMobileDrawer } from "@src/features/mobileAnalytics/shared/hooks/useMobileDrawer";

export const MobileDrawerManager = () => {
  const drawer = useMobileDrawer();
  const activeDrawerConfig = drawer.getActiveDrawerConfig();

  if (!activeDrawerConfig?.content) {
    return null;
  }

  return (
    <IgMobileDrawer
      open={drawer.activeDrawer !== null}
      onClose={drawer.closeDrawer}
      onOpen={() => {}}
      header={activeDrawerConfig.header}
      maxHeight={activeDrawerConfig.maxHeight}
      headerLeftAdornment={activeDrawerConfig.headerLeftAdornment}
    >
      {activeDrawerConfig.content}
    </IgMobileDrawer>
  );
};
